// contrast.ts
import { hexToRgb } from './oklch';

export function relLuminance(hex: string): number {
  const [r, g, b] = hexToRgb(hex).map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastRatio(a: string, b: string): number {
  const l1 = relLuminance(a),
    l2 = relLuminance(b);
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
}

export function bestText(bg: string, light = '#ffffff', dark = '#0d1117'): string {
  return contrastRatio(light, bg) >= contrastRatio(dark, bg) ? light : dark;
}
